import { Grid } from '@mui/material';
import React, { useState } from 'react';
import LoadingSpinner from '../../../../components/Components/LoadingSpinner';
import TableX from '../../../../components/Tables/TableX';
import ButtonComponent from '../../../../components/Buttons/ButtonComponent';
import CustomizeButtonComponent from '../../../../components/Buttons/CustomizeButtonComponent';
import { Icon, Paginate, PopUp, showToast } from '../../../../components/ui';
import ApiService from '../../../../services/ApiService';
import { getDefaultDateFormat, setDateFormat } from '../../../../utils/date';

const SelectDataEPL = (props) => {
    const paramRegClosingPeriod = 'regClosingPeriod/regClosingPeriod';
    const [rowsCount, setRowsCount] = useState(50);
    const [numPage, setNumPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [filterBy, setFilterBy] = useState([]);
    const [stateX, setStateX] = useState({});
    const [sortArr, setSortArr] = useState([]);
    const [goTo, setGoTo] = useState(1);

    const emptyState = () => {
        setNumPage(1);
        setRowsCount(50);
        props.setTotalRows(50);
        setGoTo(1);
        setSortArr([]);
        setFilter([]);
        setFilterBy([]);
        setStateX({});
    };

    function Select() {
        if (props.SelectedData.id === undefined) {
            showToast({ type: 'error', message: 'Please Select Data!' });
        }
        else {
            props.setIsLoadingBackDrop(true);
            props.setIsClosed(false);
            props.setEPLId(props.SelectedData.id);
            props.setPeriod(props.SelectedData.period);
            props.setYearPeriod(props.SelectedData.yearPeriod);
            props.setShipmentId(props.isGeneralPR ? props.SelectedData.id : props.SelectedData.shipmentId);
            props.GetContainerSizeData(1, 100, props.isGeneralPR ? props.SelectedData.id : props.SelectedData.shipmentId);
            props.setShipmentNo(props.SelectedData.shipmentNo);
            props.setPrincipleBy(props.SelectedData.jobOwnerId);
            props.setBookingConfirmationId(props.SelectedData.bookingId);
            props.setBookingConfirmationNumber(props.SelectedData.bookingNo);
            props.setRequester(props.SelectedData.requester);
            props.setTicketId(props.SelectedData.ticketId);

            props.setVolume20(props.SelectedData.shipVol20Amount);
            if (props.SelectedData.shipVol20Amount > 0) {
                props.setIsVolume20(true);
            }

            props.setVolume40(props.SelectedData.shipVol40Amount);
            if (props.SelectedData.shipVol40Amount > 0) {
                props.setIsVolume40(true);
            }

            props.setVolume45(props.SelectedData.shipVol45Amount);
            if (props.SelectedData.shipVol45Amount > 0) {
                props.setIsVolume45(true);
            }

            props.setVolumeCBM(props.SelectedData.shipVolCBMAmount);
            if (props.SelectedData.shipVolCBMAmount > 0) {
                props.setIsVolumeCBM(true);
            }

            props.setCustomerId(0);
            props.setCustomerName('');
            props.setPersonalId(0);
            props.setPersonalName('');

            props.setPaymentRequestDetail([]);

            if (props.jobType.serviceType === 'Export' || props.jobType.serviceType === '') {
                setDateFormat(props.SelectedData.etd, props.setET);
            }
            else {
                setDateFormat(props.SelectedData.eta, props.setET);
            }

            ApiService.RegClosingPeriodPostById(paramRegClosingPeriod, getDefaultDateFormat(new Date()))
                .then((response) => {
                    if (response.data.code === 200) {
                        let data = response.data.data.closingPeriod;

                        if (props.SelectedData.yearPeriod === data.yearPeriod) {
                            if (props.SelectedData.period === data.period) {
                                let currentDate = new Date();
                                let dayOfMonth = currentDate.getDate();
                                let currentMonth = currentDate.getMonth();
                                if (currentMonth > props.SelectedData.period) {
                                    if (dayOfMonth > 5) {
                                        props.setIsClosed(true);
                                        localStorage.setItem('isClosedEPL', JSON.stringify(true))
                                    }
                                    else {
                                        props.setIsClosed(false);
                                        localStorage.setItem('isClosedEPL', JSON.stringify(false))
                                    }
                                }
                                else {
                                    props.setIsClosed(false);
                                    localStorage.setItem('isClosedEPL', JSON.stringify(false))
                                }
                            }
                            else if (props.SelectedData.period < data.period) {
                                props.setIsClosed(true);
                                localStorage.setItem('isClosedEPL', JSON.stringify(true))
                            }
                            else {
                                props.setIsClosed(false);
                                localStorage.setItem('isClosedEPL', JSON.stringify(false))
                            }
                        }
                        else {
                            if (props.SelectedData.yearPeriod === undefined) {
                                props.setIsClosed(false);
                                localStorage.setItem('isClosedEPL', JSON.stringify(false))
                            }
                            else {
                                props.setIsClosed(true);
                                localStorage.setItem('isClosedEPL', JSON.stringify(true))
                            }
                        }
                        props.setIsLoadingBackDrop(false);
                    }
                })
                .catch(function (error) {
                    props.setIsLoadingBackDrop(false);
                    props.setIsClosed(false);
                    localStorage.setItem('isClosedEPL', JSON.stringify(false))
                })
        }

        emptyState();

        props.setIsModal(false);
    }

    function Cancel() {
        emptyState();
        props.handleClick();
    };

    const handleReset = () => {
        emptyState();
        props.getDataHeader(1, 50);
    };

    function CellDoubleClick(row) {
        Select();
    }

    const onChangePaging = (value) => {
        setNumPage(value);
        props.getDataHeader(value, rowsCount, filter, sortArr);
    }

    const onChangeLimit = (value) => {
        setNumPage(1);
        setRowsCount(value);
        props.getDataHeader(1, value, filter, sortArr);
    }

    const mainContainer = (
        <>
            <Grid item xs={12} style={{ width: "100%", borderRadius: "5px" }}>
                <div>
                    {
                        ButtonComponent.RefreshButton(
                            sortArr,
                            rowsCount,
                            props.columnData,
                            setGoTo,
                            handleReset,
                            setFilterBy,
                            filterBy,
                            setFilter,
                            setNumPage,
                            setRowsCount,
                            props.getDataHeader,
                            stateX,
                            setStateX
                        )
                    }
                </div>

                <div
                    className="rounded-10 table-responsive"
                    style={{
                        maxHeight: '375px',
                        marginTop: '16px',
                        padding: '2px 16px',
                        borderRadius: '12px',
                        background: '#F2F2F2'
                    }}
                >
                    {
                        props.isLoading ?
                            (
                                <LoadingSpinner />
                            )
                            :
                            (
                                <>
                                    <div className="mt-1">
                                        <TableX 
                                            uniqueKey={'id'}
                                            goTo={goTo}
                                            rowsCount={rowsCount}
                                            setNumPage={setNumPage}
                                            setRowsCount={setRowsCount}
                                            getData={props.getDataHeader}
                                            columnData={props.columnData}
                                            dataMap={props.dataMap}
                                            SelectedData={props.SelectedData}
                                            setSelectedData={props.setSelectedData}
                                            setFilter={setFilter}
                                            setFilterBy={setFilterBy}
                                            CellDoubleClick={CellDoubleClick}
                                            stateX={stateX}
                                            setStateX={setStateX}
                                            sortArr={sortArr}
                                            setSortArr={setSortArr}
                                            setGoTo={setGoTo}
                                        />
                                    </div>
                                </>
                            )
                    }
                </div>

                <div style={{ marginTop: '16px' }}>
                    <Paginate
                        page={numPage}
                        limit={rowsCount}
                        totalData={props.totalRows}
                        onChange={onChangePaging}
                        onChangeLimit={onChangeLimit}
                    />
                </div>
            </Grid>
        </>
    );

    return (
        <PopUp
            id='modal-id'
            icon={
                <Icon
                    iconName={'account'}
                    svgIconProps={{
                        htmlColor: '#0087C2',
                        sx: {
                            height: '24px',
                            width: '24px'
                        }
                    }}
                />
            }
            title={'Select ' + props.titleModal}
            isOpen={props.isModal}
            onClose={Cancel}
            draggable={false}
            shrinkable={false}
            disableScrollLock={false}
            maxWidth={'lg'}
            fullWidth={true}
        >
            <div style={{ padding: '0px 6px' }}>
                {mainContainer}

                <div style={{ padding: '24px 0px 0px' }}>
                    {CustomizeButtonComponent.SelectModalButton(Select)}
                </div>
            </div>
        </PopUp>
    )
}

export default SelectDataEPL;